type HeadingComponentProps = {
  fontFamily?: string;
  headingText?: string;
  margin?: string;
  fontSize?: string;
  fontSizeMobile?: string;
  fontWeight?: string;
  marginMobile?: boolean;
  marginHeadingMobile?: string;
  justifyMobile?: boolean;
  justifyLeft?: boolean;
  widthAuto?: boolean;
};

const HeadingComponent = ({
  fontFamily,
  headingText,
  margin,
  fontSize,
  fontSizeMobile,
  fontWeight,
  marginMobile,
  marginHeadingMobile,
  justifyMobile = false,
  widthAuto,
  justifyLeft = false,
}: HeadingComponentProps) => {
  const font = fontFamily ? fontFamily : "Roboto; font-weight: bold";
  return (
    <div className="heading-text-container">
      <h1 className="heading-text">{headingText}</h1>
      <style jsx>{`
        .heading-text-container {
          display: flex;
          justify-content: center;
        }
        .heading-text {
          text-align: ${justifyLeft ? "left" : "center"};
          font-family: ${font};
          width: ${widthAuto ? "auto" : justifyLeft ? "940px" : "688px"};
          font-size: ${fontSize ? fontSize : "24px"};
          margin: ${margin};
          font-weight: ${fontWeight ? fontWeight : "normal"};
        }
        @media only screen and (max-width: 700px) {
          .heading-text {
            margin: ${marginHeadingMobile ? marginHeadingMobile : "16px"};
            font-size: ${fontSizeMobile ? fontSizeMobile : "18px"};
            width: ${justifyLeft ? "100%" : "auto"};
            font-weight: ${fontWeight ? fontWeight : "normal"};
          }
          .heading-text-container {
            justify-content: ${justifyMobile ? "end" : ""};
            margin: ${marginMobile ? "0 0 0 10px" : ""};
          }
        }
      `}</style>
    </div>
  );
};

export default HeadingComponent;
